import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-purple-50 to-lavender-100 py-12 mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          {/* Logo/Name */}
          <h3 className="text-2xl md:text-3xl font-serif font-semibold text-purple-900 mb-3">
            Sylvaine Ben Klif
          </h3>
          
          {/* Tagline */}
          <p className="text-gray-600 mb-6 text-sm md:text-base">
            Constellations familiales & soins énergétiques
          </p>
          
          {/* Links */}
          <div className="flex items-center justify-center space-x-3 md:space-x-4 mb-8 flex-wrap gap-y-2">
            <Link
              to="/"
              className="text-sm text-gray-700 hover:text-purple-700 transition-colors duration-300"
            >
              Accueil
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/sylvaine"
              className="text-sm text-gray-700 hover:text-purple-700 transition-colors duration-300"
            >
              Sylvaine
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/services"
              className="text-sm text-gray-700 hover:text-purple-700 transition-colors duration-300"
            >
              Services
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/tarifs"
              className="text-sm text-gray-700 hover:text-purple-700 transition-colors duration-300"
            >
              Tarifs
            </Link>
            <span className="text-gray-400">|</span>
            <Link
              to="/contact"
              className="text-sm text-gray-700 hover:text-purple-700 transition-colors duration-300"
            >
              Contact
            </Link>
          </div>
          
          {/* Copyright */}
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} Sylvaine Ben Klif. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
